import React from "react";

import { useSetRecoilState } from "recoil";
import { modalState } from "lib/store/common";

import { Modal } from "@atsent/components";

import { Account, API, Billing, History } from "components/modals/MyAccount";

import "./MyAccount.scss";

export type MyAccountProps = {
  cx?: string;
};

export const MyAccount: React.FC<MyAccountProps> = ({ cx = "" }) => {
  const setModal = useSetRecoilState(modalState);
  return (
    <Modal
      cx={`MyAccount ${cx}`}
      close={() => setModal((m) => ({ ...m, myAccount: false }))}
      list={[
        { title: "Account", component: <Account /> },
        { title: "API", component: <API /> },
        { title: "Billing", component: <Billing /> },
        { title: "History", component: <History /> },
      ]}
    />
  );
};
